import classes from "../forms/forms.module.css";
import {useCallback, useEffect} from "react";

const ConfirmDialog = ({isOpen, onSubmit, onClose, text}) => {

    const closeModal = useCallback(() => {
        onClose();
    }, [onClose]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        }
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose, closeModal]);

    if (!isOpen) return null;


    return (
        <div className={classes.backdrop}>
            <div className={classes.modalCconfirm}>
                <h5 className="mb-3">{text}</h5>
                <div className={classes.modalButtons}>
                    <button className={classes.submit} onClick={onSubmit}>
                        Да
                    </button>
                    <button className={classes.noSubmit} onClick={onClose}>
                        Нет
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
